// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/musterkonstruktion/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const musterkonstruktionDE: PageEntry = {
  id: "post.musterkonstruktion",
  locale: "de",
  slug: "musterkonstruktion",
  seo: {
    title: "Glossar: Musterkonstruktion einfach erklärt | Dietz GmbH",
    description: "Musterkonstruktion bezieht sich auf den detaillierten Prozess, bei dem die technischen Aspekte eines Musters, insbesondere in der Textil- und Bekleidungsindustrie, ausgearbeitet we",
  },
  type: "post",
  h1: "Glossar: Musterkonstruktion einfach erklärt",
  intro: "Musterkonstruktion bezieht sich auf den detaillierten Prozess, bei dem die technischen Aspekte eines Musters, insbesondere in der Textil- und Bekleidungsindustrie, ausgearbeitet werden. Dies umfasst die Festlegung von Schnittmustern, Nähtoleranzen, Materialanforderungen und anderen technischen Details, die für die Massenproduktion relevant sind. Die Musterkonstruktion stellt sicher, dass die Entwicklungsarbeit nahtlos in die Produktionsphase übergeht und alle erforderlichen Spezifikationen erfüllt werden. Eine präzise Musterkonstruktion ist entscheidend für die Reproduzierbarkeit und Qualität von Produkten.",
  blocks: [

  ],
};
